import { render, staticRenderFns } from "./purchaseBaseInfo.vue?vue&type=template&id=622f7f34&scoped=true"
import script from "./purchaseBaseInfo.vue?vue&type=script&lang=js"
export * from "./purchaseBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./purchaseBaseInfo.vue?vue&type=style&index=0&id=622f7f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f7f34",
  null
  
)

export default component.exports